import React, { FC } from 'react';
import { isNonWorkingDay, useViewModel } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import { DayIcon } from '../../components';

interface IHeaderProps {
  weekDays: string[];
}

export const Header: FC<IHeaderProps> = observer(({ weekDays }) => {
  const calendarViewModel = useViewModel(CalendarViewModel);
  const workCalendarDay = (index: number) => calendarViewModel.findWorkCalendarDay(calendarViewModel.viewCalendar[index]);
  const isWeekendHoliday = (index: number) => isNonWorkingDay(index, workCalendarDay(index));

  return (
    <div className="row weekDays">
      <div className="day time" />
      {weekDays.map((day, index) =>
        <div
          key={day}
          className={calendarViewModel.getClassNameForWeekDay(index, isWeekendHoliday(index))}
        >
          {day} {calendarViewModel.viewCalendar[index].getDate()}
          {workCalendarDay(index)
          && (
            <DayIcon workCalendarDay={workCalendarDay(index)} />
          )}
        </div>
      )}
    </div>
  );
});
